import { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";
import { useAppDispatch } from "src/store/hooks";
import { store } from "src/redux/store";
import { fetchUserIp, getStrings, getTsInitialData } from "src/redux/slices/appSlice/AppApi";
import { initGA4, captureTrackingParams, setUserProperties, getStoredTrackingParams } from "src/analytics";

/**
 * AppInitializer Component
 * Handles initial app setup tasks like fetching translations.
 * Authenticated affiliate timers (get-affiliates-timers) are not loaded here: /flights runs save-ts-click
 * first, then chains get-affiliates-timers inside saveTsClicksApi; /hotels-and-attractions dispatches
 * getTsAffiliatesClicks on that route.
 * Note: Without the ref guard, getStrings (qry/settings/dictionary) runs twice in dev due to React StrictMode.
 */
const AppInitializer: React.FC = () => {
    const dispatch = useAppDispatch();
    const initialFetchDone = useRef(false);

    useEffect(() => {
        if (initialFetchDone.current) return;
        initialFetchDone.current = true;

        // Initialize Google Tag Manager
        const gtmId = import.meta.env.VITE_GTM_ID;
        if (gtmId) {
            TagManager.initialize({ gtmId });
        }

        initGA4({
            measurementId: import.meta.env.VITE_GA4_MEASUREMENT_ID || '',
            sendPageViews: false,
        });

        captureTrackingParams();
        
        const trackingParams = getStoredTrackingParams();
        if (trackingParams) {
            setUserProperties({
                utm_source: trackingParams.utm_source,
                utm_medium: trackingParams.utm_medium,
                utm_campaign: trackingParams.utm_campaign,
                variation: trackingParams.variation,
                cid_enc: trackingParams.cid_enc,
            });
        }

        dispatch(getStrings());
        dispatch(getTsInitialData());
        // if (!store.getState().app.userIp) { 
        // // TODO: Uncomment this when Efrat Smoller will approve getting the user IP 
        //     dispatch(fetchUserIp());
        // }
    }, [dispatch]);

    return null; // This component doesn't render anything
};

export default AppInitializer;

